/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

export const BuilderNotEnabledTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.BuilderNotEnabled';
export const BuilderNotEnabledDiscriminant = 'BUILDER_NOT_ENABLED';
export const BuilderNotEnabledDiscriminantKey = 'type';
/**
 *  The caller (portal and/or user) is not in the Breeze Builder cohort (the
 *  {@code DpgDevexAgents:BuilderWorker} gate). Thrown only from endpoints where both a portalId and
 *  userId are available, so the gate can honor portal-OR-user ungating. Not counted as a user error
 *  — a non-cohort caller reaching a gated endpoint is expected, not an alertable fault.
 *  <p>Adding this subtype widens the {@code Type} enum, which {@code chirp-schema-evolution} flags
 *  as risky ("upgrade all clients before any server"). Accepted knowingly. {@code getType()} is a
 *  {@link WireSafeEnum}, so the discriminant field itself decodes an unknown
 *  {@code BUILDER_NOT_ENABLED} without throwing — but that only covers the enum field, not
 *  necessarily every consumer's whole-message decode path. The actual guarantee is rollout order:
 *  this is a frontend error surface, so the FE client ships with the new schema, and any old CHIRP
 *  caller only ever sees this on the newly gated endpoints. Roll clients before servers if in doubt.
 */
export type BuilderNotEnabled = {
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.BuilderNotEnabled';
} & { type?: 'BUILDER_NOT_ENABLED' };

export const ClientErrorDiscriminantKey = 'type';
export type ClientError =
  | WorkspaceNotFound
  | WorkspaceByProjectNameNotFound
  | WorkspaceByConversationNotFound
  | VersionNotFound
  | VersionNotCompleted
  | VersionNotRestorable
  | VersionByConversationNotFound
  | RateLimitExceeded
  | InvalidWorkspaceIcon
  | BuilderNotEnabled
  | InvalidWorkspaceInfo
  | ReleaseManagedAppPublishNotSupported
  | ReleaseManagementNotEnabledForPortal
  | NotSupportedOnRoute;

export const InvalidWorkspaceIconTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.InvalidWorkspaceIcon';
export const InvalidWorkspaceIconDiscriminant = 'INVALID_WORKSPACE_ICON';
export const InvalidWorkspaceIconDiscriminantKey = 'type';
export type InvalidWorkspaceIcon = {
  reason: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.InvalidWorkspaceIcon';
} & { type?: 'INVALID_WORKSPACE_ICON' };

export const InvalidWorkspaceInfoTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.InvalidWorkspaceInfo';
export const InvalidWorkspaceInfoDiscriminant = 'INVALID_WORKSPACE_INFO';
export const InvalidWorkspaceInfoDiscriminantKey = 'type';
/**
 *  A workspace-info override (app name or description) failed validation — currently only the
 *  per-field length caps enforced by {@code updateInfo}.
 *  <p>Declared last (and registered last in {@code @JsonSubTypes} / the {@code Type} enum) on
 *  purpose: it takes a new trailing Avro union slot instead of displacing an existing subtype, so
 *  {@code chirp-schema-evolution} treats it as a (risky-but-rollout-able) addition rather than an
 *  unsafe rename. Same accepted posture as {@link BuilderNotEnabledIF}: a frontend error surface
 *  shipping in lockstep with the FE, and {@code getType()} is a {@link WireSafeEnum} so the
 *  discriminant decodes an unknown {@code INVALID_WORKSPACE_INFO} without throwing. Roll clients
 *  before servers if in doubt.
 */
export type InvalidWorkspaceInfo = {
  reason: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.InvalidWorkspaceInfo';
} & { type?: 'INVALID_WORKSPACE_INFO' };

export const NotSupportedOnRouteTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.NotSupportedOnRoute';
export const NotSupportedOnRouteDiscriminant = 'NOT_SUPPORTED_ON_ROUTE';
export const NotSupportedOnRouteDiscriminantKey = 'type';
/**
 *  Fork, restore or clone of a Breeze Assistant-route workspace, refused until the route can carry
 *  its code history and pinned skill into a new conversation (DPGBB-1138 lifts it). Declared last
 *  for the same Avro union-slot reason as {@link InvalidWorkspaceInfoIF}.
 */
export type NotSupportedOnRoute = {
  workspaceId: number;
  action: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.NotSupportedOnRoute';
} & { type?: 'NOT_SUPPORTED_ON_ROUTE' };

export const RateLimitExceededTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.RateLimitExceeded';
export const RateLimitExceededDiscriminant = 'RATE_LIMIT_EXCEEDED';
export const RateLimitExceededDiscriminantKey = 'type';
export type RateLimitExceeded = {
  limitName: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.RateLimitExceeded';
} & { type?: 'RATE_LIMIT_EXCEEDED' };

export const ReleaseManagedAppPublishNotSupportedTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.ReleaseManagedAppPublishNotSupported';
export const ReleaseManagedAppPublishNotSupportedDiscriminant =
  'RELEASE_MANAGED_APP_PUBLISH_NOT_SUPPORTED';
export const ReleaseManagedAppPublishNotSupportedDiscriminantKey = 'type';
export type ReleaseManagedAppPublishNotSupported = {
  platformVersion: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.ReleaseManagedAppPublishNotSupported';
} & { type?: 'RELEASE_MANAGED_APP_PUBLISH_NOT_SUPPORTED' };

export const ReleaseManagementNotEnabledForPortalTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.ReleaseManagementNotEnabledForPortal';
export const ReleaseManagementNotEnabledForPortalDiscriminant =
  'RELEASE_MANAGEMENT_NOT_ENABLED_FOR_PORTAL';
export const ReleaseManagementNotEnabledForPortalDiscriminantKey = 'type';
export type ReleaseManagementNotEnabledForPortal = {
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.ReleaseManagementNotEnabledForPortal';
} & { type?: 'RELEASE_MANAGEMENT_NOT_ENABLED_FOR_PORTAL' };

export const VersionByConversationNotFoundTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.VersionByConversationNotFound';
export const VersionByConversationNotFoundDiscriminant =
  'VERSION_BY_CONVERSATION_NOT_FOUND';
export const VersionByConversationNotFoundDiscriminantKey = 'type';
export type VersionByConversationNotFound = {
  conversationId: number;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.VersionByConversationNotFound';
} & { type?: 'VERSION_BY_CONVERSATION_NOT_FOUND' };

export const VersionNotCompletedTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.VersionNotCompleted';
export const VersionNotCompletedDiscriminant = 'VERSION_NOT_COMPLETED';
export const VersionNotCompletedDiscriminantKey = 'type';
export type VersionNotCompleted = {
  versionId: number;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.VersionNotCompleted';
} & { type?: 'VERSION_NOT_COMPLETED' };

export const VersionNotFoundTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.VersionNotFound';
export const VersionNotFoundDiscriminant = 'VERSION_NOT_FOUND';
export const VersionNotFoundDiscriminantKey = 'type';
export type VersionNotFound = {
  versionId: number;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.VersionNotFound';
} & { type?: 'VERSION_NOT_FOUND' };

export const VersionNotRestorableTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.VersionNotRestorable';
export const VersionNotRestorableDiscriminant = 'VERSION_NOT_RESTORABLE';
export const VersionNotRestorableDiscriminantKey = 'type';
export type VersionNotRestorable = {
  versionId: number;
  reason?: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.VersionNotRestorable';
} & { type?: 'VERSION_NOT_RESTORABLE' };

export const WorkspaceByConversationNotFoundTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceByConversationNotFound';
export const WorkspaceByConversationNotFoundDiscriminant =
  'WORKSPACE_BY_CONVERSATION_NOT_FOUND';
export const WorkspaceByConversationNotFoundDiscriminantKey = 'type';
export type WorkspaceByConversationNotFound = {
  conversationId: number;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceByConversationNotFound';
} & { type?: 'WORKSPACE_BY_CONVERSATION_NOT_FOUND' };

export const WorkspaceByProjectNameNotFoundTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceByProjectNameNotFound';
export const WorkspaceByProjectNameNotFoundDiscriminant =
  'WORKSPACE_BY_PROJECT_NAME_NOT_FOUND';
export const WorkspaceByProjectNameNotFoundDiscriminantKey = 'type';
export type WorkspaceByProjectNameNotFound = {
  projectName: string;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceByProjectNameNotFound';
} & { type?: 'WORKSPACE_BY_PROJECT_NAME_NOT_FOUND' };

export const WorkspaceNotFoundTypename =
  'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceNotFound';
export const WorkspaceNotFoundDiscriminant = 'WORKSPACE_NOT_FOUND';
export const WorkspaceNotFoundDiscriminantKey = 'type';
export type WorkspaceNotFound = {
  workspaceId: number;
  portalId?: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.dpg.devex.agents.models.rpc.WorkspaceNotFound';
} & { type?: 'WORKSPACE_NOT_FOUND' };

/**
 *  A single app-info field (name or description) split into the AI-generated value captured at build
 *  time and an optional customer override, plus an explicit {@code overridden} flag telling the FE
 *  which one to display. All three are pure plumbing: the backend forwards them, it does not infer
 *  {@code overridden} from the presence of an override.
 */
export type AppInfoField = {
  aiGenerated?: string;
  userOverride?: string;
  overridden: boolean;
};

export type CloneWorkspaceRequest = { workspaceId: number; name?: string };

export type CreateWorkspaceRequest = { name?: string };

export type CreateWorkspaceResponse = { id: number };

export type DeleteWorkspaceRequest = { id: number };

export type ForkVersionRequest = { parentVersionId: number; prompt: string };

export type ForkVersionResponse = { version: VersionResponse };

export type FullWorkspaceResponse = {
  id: number;
  userId: number;
  projectName?: string;
  name?: string;
  route?: WorkspaceRoute;
  appId?: number;
  iconUrl?: string;
  publishedVersionId?: number;
  currentVersionId?: number;
  versions: Default<VersionResponse[]>;
  favorite?: boolean;
  iconGenerating?: boolean;
  appName: AppInfoField;
  appDescription: AppInfoField;
};

export type GetWorkspaceComponentsRequest = { versionId: number };

export type GetWorkspaceComponentsResponse = {
  components: Default<WorkspaceComponent[]>;
};

export type GetWorkspacesPageViaIdRequest = {
  namePart?: string;
  sort: Default<WorkspaceIdSort>;
  offset: Default<number>;
  pageLength: Default<number>;
};

export type GetWorkspacesPageViaIdResponse = {
  results: Default<WorkspaceSummaryResponse[]>;
  hasMore: boolean;
  offset: number;
};

export type GetWorkspacesPageViaOffsetRequest = {
  namePart?: string;
  sort: Default<WorkspaceOffsetSort>;
  offset: Default<number>;
  pageLength: Default<number>;
};

export type GetWorkspacesPageViaOffsetResponse = {
  results: Default<WorkspaceSummaryResponse[]>;
  hasMore: boolean;
  offset: number;
};

export type PublishWorkspaceRequest = { versionId: number };

export type PublishWorkspaceResponse = { deployId: number; appId?: number };

export type RestoreVersionRequest = { versionId: number };

export type RestoreVersionResponse = { version: VersionResponse };

export type StartWorkspaceRequest = { initialPrompt: string; name?: string };

export type StartWorkspaceResponse = {
  ablyChannelId?: string;
  id: number;
  userId: number;
  projectName?: string;
  name?: string;
  route?: WorkspaceRoute;
  appId?: number;
  iconUrl?: string;
  publishedVersionId?: number;
  currentVersionId?: number;
  versions: Default<VersionResponse[]>;
  favorite?: boolean;
  iconGenerating?: boolean;
};

export type SuggestedPromptsRequest = {};

export type SuggestedPromptsResponse = { suggestedPrompts: Default<string[]> };

export type ToggleFavoriteRequest = {
  workspaceId: number;
  namePart?: string;
  offset: Default<number>;
  pageLength: Default<number>;
};

export type ToggleFavoriteResponse = {
  favorite: boolean;
  results: Default<WorkspaceSummaryResponse[]>;
  hasMore: boolean;
  offset: number;
};

export type UnpublishWorkspaceRequest = { id: number };

/**
 *  Partial patch for a workspace's metadata. Each field is optional: absent means "leave unchanged",
 *  never "clear". Lets the Edit-info modal Save carry name/app-info overrides/icon together, while
 *  inline rename-on-blur can send name-only without touching the app-info overrides.
 *  <p><b>App-info override pairing contract.</b> The four app-info fields are applied
 *  independently, each via {@code COALESCE(:param, col)} — an absent field is left at its stored
 *  value; the backend does <i>not</i> couple a value to its flag or infer one from the other
 *  ({@code *Overridden} is pure plumbing). So a caller changing an override <b>must send the value
 *  and its matching {@code *Overridden} flag together</b>: sending {@code appNameUserOverride}
 *  without {@code appNameOverridden=true} stores text the reads won't surface (the struct still
 *  reports {@code overridden=false}), and sending the flag without the value flips display onto a
 *  stale/empty stored value. A partial payload applies partially and silently — no error is raised.
 *  There is likewise no way to <i>clear</i> an override here (absent = unchanged; an empty string is
 *  stored as empty, not null).
 */
export type UpdateWorkspaceInfoRequest = {
  id: number;
  name?: string;
  appNameUserOverride?: string;
  appDescriptionUserOverride?: string;
  appNameOverridden?: boolean;
  appDescriptionOverridden?: boolean;
  iconBase64?: string;
};

export type VersionDeployStatus =
  | 'PENDING'
  | 'SUCCEEDED'
  | 'FAILED'
  | unhandledEnumCase;

export type VersionResponse = {
  id: number;
  conversationId: number;
  turnId?: number;
  number: number;
  buildId?: number;
  parentId?: number;
  createdAt: number;
  completedAt?: number;
  turnEndedAt?: number;
  blurb?: string;
  conversationHead?: boolean;
  updatedAt: number;
  deployId?: number;
  deployStatus?: VersionDeployStatus;
  deployError?: string;
};

export type WorkspaceByConversationRequest = { conversationId: number };

export type WorkspaceByIdRequest = { id: number };

export type WorkspaceByProjectNameRequest = { projectName: string };

export type WorkspaceComponent = { uid: string; componentType: string };

export type WorkspaceIdSort = 'ID_ASC' | unhandledEnumCase;

export type WorkspaceOffsetSort = 'UPDATED_DESC' | unhandledEnumCase;

export type WorkspaceRoute =
  | 'CUSTOM'
  | 'BA_APP_BUILDER_INTERIM'
  | unhandledEnumCase;

export type WorkspaceSummaryResponse = {
  id: number;
  userId?: number;
  projectName?: string;
  name?: string;
  appId?: number;
  iconUrl?: string;
  publishedVersionId?: number;
  updatedAt: number;
  favorite?: boolean;
  iconGenerating?: boolean;
  appName: AppInfoField;
  appDescription: AppInfoField;
};

export type CreateRequestType = Requestify<CreateWorkspaceRequest>;
export type CreateResponseType = CreateWorkspaceResponse;
export type CreateErrorType = ClientError & HubspotMetadata;
export const createRpc: ChirpAvroRpcDetails<
  CreateRequestType,
  CreateResponseType,
  CreateErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'JriyNxzY1zl8-TNS3KAWOKP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type StartRequestType = Requestify<StartWorkspaceRequest>;
export type StartResponseType = StartWorkspaceResponse;
export type StartErrorType = ClientError & HubspotMetadata;
export const startRpc: ChirpAvroRpcDetails<
  StartRequestType,
  StartResponseType,
  StartErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'KYet13-tzVRc15VcDo3itqP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ForkRequestType = Requestify<ForkVersionRequest>;
export type ForkResponseType = ForkVersionResponse;
export type ForkErrorType = ClientError & HubspotMetadata;
export const forkRpc: ChirpAvroRpcDetails<
  ForkRequestType,
  ForkResponseType,
  ForkErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'fork',
  auth: 'app',
  fingerprint: 'u-Bq8y08aiLVfhQ53aLGk6P-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RestoreRequestType = Requestify<RestoreVersionRequest>;
export type RestoreResponseType = RestoreVersionResponse;
export type RestoreErrorType = ClientError & HubspotMetadata;
export const restoreRpc: ChirpAvroRpcDetails<
  RestoreRequestType,
  RestoreResponseType,
  RestoreErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'restore',
  auth: 'app',
  fingerprint: 'x-Bk5tNEi-exvzp1u3-RKqP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CloneRequestType = Requestify<CloneWorkspaceRequest>;
export type CloneResponseType = FullWorkspaceResponse;
export type CloneErrorType = ClientError & HubspotMetadata;
export const cloneRpc: ChirpAvroRpcDetails<
  CloneRequestType,
  CloneResponseType,
  CloneErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'clone',
  auth: 'app',
  fingerprint: '45L-OPnCwF74TFBd-KKaEaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetByIdRequestType = Requestify<WorkspaceByIdRequest>;
export type GetByIdResponseType = FullWorkspaceResponse;
export type GetByIdErrorType = ClientError & HubspotMetadata;
export const getByIdRpc: ChirpAvroRpcDetails<
  GetByIdRequestType,
  GetByIdResponseType,
  GetByIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'dCPJfMeJRp34TFBd-KKaEaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetComponentsRequestType =
  Requestify<GetWorkspaceComponentsRequest>;
export type GetComponentsResponseType = GetWorkspaceComponentsResponse;
export type GetComponentsErrorType = ClientError & HubspotMetadata;
export const getComponentsRpc: ChirpAvroRpcDetails<
  GetComponentsRequestType,
  GetComponentsResponseType,
  GetComponentsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getComponents',
  auth: 'app',
  fingerprint: 'SfJGDjpr8KXCe2cNBEmY5qP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetByProjectNameRequestType =
  Requestify<WorkspaceByProjectNameRequest>;
export type GetByProjectNameResponseType = FullWorkspaceResponse;
export type GetByProjectNameErrorType = ClientError & HubspotMetadata;
export const getByProjectNameRpc: ChirpAvroRpcDetails<
  GetByProjectNameRequestType,
  GetByProjectNameResponseType,
  GetByProjectNameErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getByProjectName',
  auth: 'app',
  fingerprint: '1aptyq7LV1_4TFBd-KKaEaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetByConversationRequestType =
  Requestify<WorkspaceByConversationRequest>;
export type GetByConversationResponseType = FullWorkspaceResponse;
export type GetByConversationErrorType = ClientError & HubspotMetadata;
export const getByConversationRpc: ChirpAvroRpcDetails<
  GetByConversationRequestType,
  GetByConversationResponseType,
  GetByConversationErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getByConversation',
  auth: 'app',
  fingerprint: 'tALXcKKsrY_4TFBd-KKaEaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateInfoRequestType = Requestify<UpdateWorkspaceInfoRequest>;
export type UpdateInfoResponseType = FullWorkspaceResponse;
export type UpdateInfoErrorType = ClientError & HubspotMetadata;
export const updateInfoRpc: ChirpAvroRpcDetails<
  UpdateInfoRequestType,
  UpdateInfoResponseType,
  UpdateInfoErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'updateInfo',
  auth: 'app',
  fingerprint: 'W7xOSaiwSon4TFBd-KKaEaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteRequestType = Requestify<DeleteWorkspaceRequest>;
export type DeleteResponseType = ChirpVoid;
export type DeleteErrorType = ClientError & HubspotMetadata;
export const deleteRpc: ChirpAvroRpcDetails<
  DeleteRequestType,
  DeleteResponseType,
  DeleteErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'mTr0JO772WiOUe2e_r4XmaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PublishRequestType = Requestify<PublishWorkspaceRequest>;
export type PublishResponseType = PublishWorkspaceResponse;
export type PublishErrorType = ClientError & HubspotMetadata;
export const publishRpc: ChirpAvroRpcDetails<
  PublishRequestType,
  PublishResponseType,
  PublishErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'publish',
  auth: 'app',
  fingerprint: '0fIE-rDnL1JhW2wE01xS4aP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UnpublishRequestType = Requestify<UnpublishWorkspaceRequest>;
export type UnpublishResponseType = ChirpVoid;
export type UnpublishErrorType = ClientError & HubspotMetadata;
export const unpublishRpc: ChirpAvroRpcDetails<
  UnpublishRequestType,
  UnpublishResponseType,
  UnpublishErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'unpublish',
  auth: 'app',
  fingerprint: 'nWiR28K1pjWOUe2e_r4XmaP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPageViaIdRequestType = Requestify<GetWorkspacesPageViaIdRequest>;
export type GetPageViaIdResponseType = GetWorkspacesPageViaIdResponse;
export type GetPageViaIdErrorType = ClientError & HubspotMetadata;
export const getPageViaIdRpc: ChirpAvroRpcDetails<
  GetPageViaIdRequestType,
  GetPageViaIdResponseType,
  GetPageViaIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getPageViaId',
  auth: 'app',
  fingerprint: 'UfQTRpAwBk0dEdJGDPs67aP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPageViaOffsetRequestType =
  Requestify<GetWorkspacesPageViaOffsetRequest>;
export type GetPageViaOffsetResponseType = GetWorkspacesPageViaOffsetResponse;
export type GetPageViaOffsetErrorType = ClientError & HubspotMetadata;
export const getPageViaOffsetRpc: ChirpAvroRpcDetails<
  GetPageViaOffsetRequestType,
  GetPageViaOffsetResponseType,
  GetPageViaOffsetErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getPageViaOffset',
  auth: 'app',
  fingerprint: 'Tj_izgFnSUKUIjmgDRRj0qP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ToggleFavoriteRequestType = Requestify<ToggleFavoriteRequest>;
export type ToggleFavoriteResponseType = ToggleFavoriteResponse;
export type ToggleFavoriteErrorType = ClientError & HubspotMetadata;
export const toggleFavoriteRpc: ChirpAvroRpcDetails<
  ToggleFavoriteRequestType,
  ToggleFavoriteResponseType,
  ToggleFavoriteErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'toggleFavorite',
  auth: 'app',
  fingerprint: 'knuDSYheQYQNtx0NX9-7yqP-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSuggestedPromptsRequestType =
  Requestify<SuggestedPromptsRequest>;
export type GetSuggestedPromptsResponseType = SuggestedPromptsResponse;
export type GetSuggestedPromptsErrorType = ClientError & HubspotMetadata;
export const getSuggestedPromptsRpc: ChirpAvroRpcDetails<
  GetSuggestedPromptsRequestType,
  GetSuggestedPromptsResponseType,
  GetSuggestedPromptsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc',
  rpcName: 'getSuggestedPrompts',
  auth: 'app',
  fingerprint: '0pFBLyfCT9ZIdDI6UzJ2Z6P-u9wCnyPJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
